export default __webpack_public_path__ + "static/media/balastro-electronico-600W-cultivo-interior.cdec0030.jpg";